// extracted by mini-css-extract-plugin
export default {"container":"aE-z","header":"bE-z","details":"cE-z","link":"dE-z"};